var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.03 0H12C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H12.03C18.6574 24 24.03 18.6274 24.03 12C24.03 5.37258 18.6574 0 12.03 0Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.5498 6.80012H12.4498C10.4098 6.80012 9.3398 7.83012 9.3398 9.35012C9.3398 11.0601 10.0798 11.8701 11.5998 12.9001L12.8498 13.7401L9.2498 19.1301H6.5498L9.7898 14.3101C7.9198 12.9801 6.8798 11.6801 6.8798 9.49012C6.8798 6.75012 8.7998 4.87012 12.4298 4.87012H16.0298V19.1101H13.5498V6.80012Z",
      "fill": "#373855"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }